<script>
  import ApplicationState from "../../../../Stores/applicationStates"
  import { timeAgo } from "../Script/time"
  import CertDetails from "./certDetails.svelte"
  import { getRequest, postRequest } from "../../../../Script/apiMethods"
  import notify from "../../../../Script/notify"
  import User from "./user.svelte"
  import Modal from "../../MultiSigner/Pages/CreateDocket/Components/modal.svelte"
  import LoadingScreen from "../../../Publish/SinglePublish/Components/loadingScreen.svelte"
  import Dropdown from "./dropdown.svelte"

  export let users = []
  export let docStatus = ""
  export let publishID = ""
  export let signCnMismatchID = ""

  export let docCreated
  export let docketID
  export let uuid

  let loaderMsg = "Fetching Docket Details"
  let showLoader = false
  export let isModeNotSelected
  export let isESignPending
  export let certData = []
  export let isPdfDigitallySigned = false
  export let isApproversFound

  let showCertDetailsModal = false

  let showModeSelectionModal = false

  let activeID = ""

  let activeSigner = ""

  let certDetails = {}

  let signModeDetails = {}

  let externalSigningModes = ["ESign", "Aadhaar ESign", "DSC Digital Signing (Dongle)"]

  /**
   * @typedef {Object} closeNotification
   * @property {Function} close - Closes the notification.
   */
  let closeNotification = {
    close() {},
  }

  /**
   * Processes a chain of digital certificates by transforming them into a more readable format.
   * It iterates through each certificate in the chain and restructures its properties.
   *
   * @param {Array<Object>} chain - An array of digital certificate objects.
   * @returns {Array<Object>} The processed array of certificate objects with restructured properties.
   */
  const processCertChain = (chain = []) => {
    try {
      return chain.map((item) => {
        const { subjectRDNs, issuerRDNS, details = {}, ...rest } = item

        const parsed = { details: { ...details } }

        for (const key in rest) {
          const value = rest[key]

          if (typeof value !== "object" || value === null) {
            parsed.details[key] = value
            continue
          }

          const entries = Object.entries(value)
          if (!entries.length) {
            parsed[key] = value
            continue
          }

          // Fast check using only first entry (instead of .every)
          const [firstKey, firstVal] = entries[0]
          const isKVArray = !isNaN(firstKey) && typeof firstVal === "string" && firstVal.includes("=")

          if (isKVArray) {
            const obj = {}
            for (let i = entries.length - 1; i >= 0; i--) {
              const v = entries[i][1]
              const idx = v.indexOf("=")
              obj[v.slice(0, idx)] = v.slice(idx + 1)
            }
            parsed[key] = obj
          } else {
            const obj = {}
            for (let i = entries.length - 1; i >= 0; i--) {
              const [k, v] = entries[i]
              obj[k] = v
            }
            parsed[key] = obj
          }
        }

        return parsed
      })
    } catch (error) {
      closeNotification.close()
      const info = "PAGE: Doc Multi-Signer (Status Page)\nEVENT: While processing digital certificate details"
      closeNotification = notify.danger(error, info)
    }
  }

  // const handleCertDetailsFetching = async () => {
  //   try {
  //     if (!certDetails[activeID] || Object.keys(certDetails[activeID]).length === 0) {
  //       showLoader = true
  //       loaderMsg = "Fetching Digital Certificate Details"
  //       console.log({ certData })

  //       if (!certData || !certData.length) throw "No digital certificate data available"

  //       let matchedItem = certData.find((item) => {
  //         if (!item.fieldName) return false
  //         const signeeID = item.fieldName.split("-")[2]
  //         return signeeID === activeID
  //       })

  //       if (!matchedItem) {
  //         matchedItem = certData.find((item) => {
  //           if (!item.signingTime) return false
  //           const matchedUser = users.find((user) => {
  //             if (!user.timestamp) return false
  //             console.log({ usertimestamp: user.timestamp, itemtimestamp: item.signingTime })
  //             const diff = Math.abs(new Date(user.timestamp).getTime() - new Date(item.signingTime).getTime())
  //             return diff < 3000 // 3 seconds tolerance
  //           })
  //           return matchedUser && matchedUser.id === activeID
  //         })
  //       }

  //       if (matchedItem) {
  //         certDetails[activeID] = processCertChain(matchedItem.certificates || [matchedItem])
  //         certDetails = { ...certDetails }
  //       }
  //     }

  //     console.log("certDetails : ", certDetails)

  //     showCertDetailsModal = true
  //   } catch (error) {
  //     console.error(error)
  //     closeNotification.close()
  //     const info = "PAGE: Doc Multi-Signer (Status Page)\nEVENT: While fetching digital certificate details"
  //     closeNotification = notify.danger(error, info)
  //   } finally {
  //     showLoader = false
  //     loaderMsg = "Fetching Docket Details"
  //   }
  // }
  const handleCertDetailsFetching = async () => {
    try {
      if (!certDetails[activeID] || Object.keys(certDetails[activeID]).length === 0) {
        showLoader = true
        loaderMsg = "Fetching Digital Certificate Details"
        console.log({ certData, activeID })

        if (!certData || !certData.length) throw "No digital certificate data available"

        let matchedItem = certData.find((item) => {
          if (!item.fieldName) return false
          const parts = item.fieldName.split("-")
          const signeeID = parts[2]
          return signeeID === activeID
        })

        if (!matchedItem) {
          const nonEsignSigners = users.filter((u) => u.status === "SIGNED" && u.mode !== "E-SIGN").sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))

          const sortedCertData = [...certData].sort((a, b) => new Date(b.signingTime) - new Date(a.signingTime))

          const activeIndex = nonEsignSigners.findIndex((u) => u.id === activeID)

          if (activeIndex !== -1 && sortedCertData[activeIndex]) {
            matchedItem = sortedCertData[activeIndex]
          }
        }

        if (matchedItem) {
          certDetails[activeID] = processCertChain(matchedItem.certificates || [matchedItem])
          certDetails = { ...certDetails }
        }
      }

      console.log("certDetails : ", certDetails)

      showCertDetailsModal = true
    } catch (error) {
      console.error(error)
      closeNotification.close()
      const info = "PAGE: Doc Multi-Signer (Status Page)\nEVENT: While fetching digital certificate details"
      closeNotification = notify.danger(error, info)
    } finally {
      showLoader = false
      loaderMsg = "Fetching Docket Details"
    }
  }

  const addSigningMode = async () => {
    try {
      if (!signModeDetails.mode) throw "Kindly choose your preferred signing method to proceed."
      showModeSelectionModal = false

      let currentUser = users.filter((user) => user.id == signModeDetails.id)[0]
      if (currentUser.mode == signModeDetails.mode) return

      showLoader = true
      loaderMsg = "Updating Signing Preference"

      const signMappings = {
        ESign: "E-SIGN",
        "Aadhaar ESign": "AADHAAR-ESIGN",
        "DSC Digital Signing (Dongle)": "DSC-TOKEN-SIGN",
      }

      const REQ_URL = "/api/pdf-signing/v2/signee/prefered-sign"
      const REQ_BODY = {
        uuid,
        email: signModeDetails.email,
        mode: signMappings[signModeDetails.mode],
      }

      await postRequest(REQ_URL, REQ_BODY)

      users = users.map((user) => {
        if (user.id == signModeDetails.id) user.mode = signMappings[signModeDetails.mode]
        return user
      })

      let signers = users.filter((user) => user.role == "SIGNER") || []

      let signersWithPreference = signers.filter((signer) => !signer.internal && !signer.mode && signer.status == "PENDING") || []
      isModeNotSelected = Boolean(signersWithPreference.length)

      let signersWithPendingESign = signers.filter((signer) => !signer.internal && signer.mode == "E-SIGN" && signer.status == "PENDING") || []
      isESignPending = Boolean(signersWithPendingESign.length)

      notify.success(`Signing Mode Preference updated successfully.`)
    } catch (error) {
      console.error(error)
      closeNotification.close()
      const info = "PAGE: Doc Multi-Signer (Status Page)\nEVENT: While updating signing mode for the selected signer"
      closeNotification = notify.danger(error, info)
    } finally {
      showLoader = false
      loaderMsg = "Fetching Docket Details"
    }
  }

  const handleEmailInvite = async (e) => {
    try {
      showLoader = true
      loaderMsg = "Sending Email"

      // Sending Email
      await getRequest(`/api/pdf-signing/v2/docket/${docketID}/mail?id=${e.detail}`, {
        headers: {
          "msign-org-token": $ApplicationState.msignToken,
        },
      })

      notify.success("Email resent successfully. You will be able to resend the invite after 30 seconds if needed.")
    } catch (error) {
      console.error(error)
      closeNotification.close()
      const info = "PAGE: Doc Multi-Signer (Status Page)\nEVENT: While sending signing invite to the selected signer through email"
      closeNotification = notify.danger(error, info)
    } finally {
      showLoader = false
      loaderMsg = "Fetching Docket Details"
    }
  }
</script>

{#if showCertDetailsModal}
  <CertDetails
    {activeSigner}
    isCNMismatch={activeID === signCnMismatchID}
    bind:certArray={certDetails[activeID]}
    on:click={() => {
      showCertDetailsModal = false
    }}
  />
{/if}

{#if showModeSelectionModal}
  <Modal
    title="Signing Mode Confirmation"
    btnName="Confirm"
    on:click={() => {
      showModeSelectionModal = false
    }}
    on:confirm={addSigningMode}
  >
    <div class="flex w-3/4 flex-col items-center gap-3 break-words p-3 text-center text-gray-d00 dark:text-gray-200 mobile:p-6">
      <p>Please select your preferred mode of signing. You can change or update your preference before the signing process begins.</p>

      <div class="relative flex w-full items-center gap-3">
        <Dropdown bind:activeItem={signModeDetails.mode} dropdownItems={externalSigningModes} />
      </div>
    </div>
  </Modal>
{/if}

{#if showLoader}
  <LoadingScreen msg={loaderMsg} />
{/if}

<ul class="!mt-6">
  <li class="relative flex gap-x-4">
    <div class="relative flex w-9 justify-center">
      <div class="z-10 flex h-9 w-9 items-center justify-center rounded-full bg-green-500 p-3 text-white">
        <i class="fa-solid fa-plus" />
      </div>
      <div class="absolute flex h-full w-1 bg-gray-500" />
    </div>
    <div class="text-xs/5 w-full pb-6 text-gray-500">
      <div class="flex w-full items-center justify-between gap-3">
        <div class="max-w-[70%] break-all text-sm font-semibold text-gray-d00 dark:text-white">
          {$ApplicationState.name}
          <span class="font-normal text-gray-500">created.</span>
        </div>

        <div class="max-w-[30%]">
          <div data-tooltip={new Date(docCreated).toLocaleString()} tooltip-position="left" class="w-fit cursor-pointer text-green-500">
            <span class="text-xs font-semibold">{timeAgo(docCreated)}</span>
          </div>
        </div>
      </div>
      <div class="mt-1 break-all font-semibold text-gray-400">{$ApplicationState.email}</div>
    </div>
  </li>

  {#each users as user (user.id)}
    <User
      {user}
      {docStatus}
      {isModeNotSelected}
      {isESignPending}
      {isApproversFound}
      {signCnMismatchID}
      on:copy
      on:cnameApproval
      on:sendInv={handleEmailInvite}
      on:click={async () => {
        activeID = user.id
        activeSigner = user.name
        await handleCertDetailsFetching()
      }}
      on:modeSelect={(e) => {
        signModeDetails = e.detail
        if (isPdfDigitallySigned) externalSigningModes = ["Aadhaar ESign", "DSC Digital Signing (Dongle)"]
        else externalSigningModes = ["ESign", "Aadhaar ESign", "DSC Digital Signing (Dongle)"]
        showModeSelectionModal = true
      }}
    />
  {/each}

  <li class="flex items-center gap-x-4">
    <div class="flex h-9 w-9 items-center justify-center rounded-full text-white {docStatus == 'REJECTED' ? 'bg-red-500' : docStatus == 'COMPLETED' ? 'bg-green-500' : 'bg-yellow-500'} p-3">
      <i class="fa-solid {docStatus == 'REJECTED' ? 'fa-xmark' : docStatus == 'COMPLETED' ? 'fa-check' : 'fa-clock'} " />
    </div>

    <div class="rounded-md px-2 py-1 text-base font-semibold {docStatus === 'REJECTED' ? 'bg-red-500/25 text-red-500' : docStatus === 'COMPLETED' ? 'bg-green-500/25 text-green-500' : 'bg-yellow-500/25 text-yellow-500'}">
      {#if isModeNotSelected}
        Waiting for Consent
      {:else if docStatus === "PENDING" || docStatus === "EMPTY"}
        Waiting for Approval
      {:else if docStatus === "APPROVED"}
        Waiting for Signing
      {:else if docStatus === "REJECTED"}
        Docket has been rejected
      {:else if docStatus === "SIGNED"}
        Waiting for Publication
      {:else}
        Docket Successfully {publishID ? "Published" : "Signed"}
      {/if}
    </div>
  </li>
</ul>
